<template>
  <div class="product-rating--outer-wrapper d-flex flex-wrap align-items-center justify-content-center">
      <div v-for="index in 5" :key="index" class="product-rating--inner-wrapper d-flex justify-content-center align-item-center">
        <b-img v-if="index <= rating" src="../assets/collection-page-cosmetics/star-filled.svg" alt="Rating Icon" class="product--rating-icon" ></b-img>
        <b-img v-else src="../assets/collection-page-cosmetics/star-blank.svg" alt="Rating Icon" class="product--rating-icon" ></b-img>
      </div>
  </div>
</template>

<script>
export default {
  name: "ProductRating",
  props: {
    userrating: Number,
    product: Number
  },
  watch: { 
    userrating: function(newVal, oldVal) {
      this.rating = newVal;
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    }
  },
  mounted(){
    this.rating = this.userrating;
    //console.log(this.userrating,'-----user rating');
	},
  data(){
    return {
      rating:-1
    }
  }
};
</script>
<style scoped lang="scss">
.product {
  &-rating {
    &--inner-wrapper {
      width: 12px;
      margin-right: 5px;
      margin-bottom: 10px;
      overflow: hidden;
      display: inline-block;
	  height:14px;

      &:last-child {
        margin-right: 0;
      }

      img {
        width: 100%;
      }
    }
  }
}
</style>